import {
  HEAVY_FIELD_CHARS,
  HEAVY_FIELD_NODES,
} from '../../../DocEditor/utils/blockSelectionUtils';

export { HEAVY_FIELD_CHARS, HEAVY_FIELD_NODES };

/** Sync clipboard writes above this hitch the cut that is trying to clear the cell. */
export const CLIPBOARD_SYNC_LIMIT = 65536;

export const fieldIsHeavy = (el, tailLength = 0) => {
  if (tailLength > 0) return true;
  if (!el) return false;
  if ((el.childElementCount || 0) > HEAVY_FIELD_NODES) return true;
  return (el.textContent || '').length > HEAVY_FIELD_CHARS;
};

/**
 * True when the selection starts at the field and runs through the visible
 * value (including up to the hidden-tail marker). Does not read the text.
 */
export const selectionConsumesField = (el) => {
  const sel = window.getSelection();
  if (!el || !sel?.rangeCount || sel.isCollapsed) return false;
  if (!el.contains(sel.anchorNode) || !el.contains(sel.focusNode)) return false;
  try {
    const range = sel.getRangeAt(0);
    const start = document.createRange();
    start.setStart(el, 0);
    start.collapse(true);
    if (range.compareBoundaryPoints(Range.START_TO_START, start) > 0) return false;

    const marker = el.querySelector('[data-large-tail]');
    if (marker) {
      const atMarker = document.createRange();
      atMarker.setStartBefore(marker);
      atMarker.collapse(true);
      return range.compareBoundaryPoints(Range.END_TO_START, atMarker) >= 0;
    }

    const full = document.createRange();
    full.selectNodeContents(el);
    return range.compareBoundaryPoints(Range.END_TO_END, full) >= 0;
  } catch {
    return false;
  }
};

export const scheduleClipboardWrite = (text) => {
  const value = String(text ?? '');
  if (!value || typeof navigator === 'undefined' || !navigator.clipboard?.writeText) return;
  const write = () => {
    navigator.clipboard.writeText(value).catch(() => {});
  };
  if (value.length > CLIPBOARD_SYNC_LIMIT) setTimeout(write, 0);
  else write();
};
